import { z } from 'zod';

export const addLocationKeywordsSearchSchema = z.object({
  locationId: z.number(),
  placeId: z.string()
});

export type AddLocationKeywordsSearch = z.infer<typeof addLocationKeywordsSearchSchema>;
